import { Badge } from '@commenda/kakashi';
import { SyntheticComplianceStatus } from '@commenda/types/src/compliance-calendar/compliances/types';
import { NonTimezoneSensitiveDate } from '@commenda/utils';
import { ComplianceStatus } from '@prisma/client';

export function FilingStatusBadge({
  status,
  syntheticStatus,
  size,
}: {
  status: ComplianceStatus;
  syntheticStatus: SyntheticComplianceStatus;
  size?: 'sm' | 'md' | 'lg';
}) {
  const isFilingCompletedOrFiled =
    status === ComplianceStatus.COMPLETED || status === ComplianceStatus.FILED;

  const isFilingActive =
    syntheticStatus === SyntheticComplianceStatus.DUE_SOON ||
    syntheticStatus === ComplianceStatus.UNDER_FILING;

  const isFilingOverdue = syntheticStatus === SyntheticComplianceStatus.OVERDUE;
  const isFilingArchived =
    syntheticStatus === SyntheticComplianceStatus.ARCHIVED;
  const isFilingExtended =
    syntheticStatus === SyntheticComplianceStatus.EXTENDED;

  const badgeSize = size || 'sm';

  if (isFilingCompletedOrFiled)
    return (
      <Badge size={badgeSize} variant="success">
        Filed
      </Badge>
    );
  if (isFilingExtended)
    return (
      <Badge size={badgeSize} variant="orange">
        Extended
      </Badge>
    );
  if (isFilingActive)
    return (
      <Badge size={badgeSize} variant="success-solid">
        Active
      </Badge>
    );
  if (isFilingOverdue)
    return (
      <Badge size={badgeSize} variant="error">
        Overdue
      </Badge>
    );
  if (isFilingArchived)
    return (
      <Badge size={badgeSize} variant="gray">
        Archived
      </Badge>
    );

  //   default is Not Started
  return (
    <Badge variant="gray" size={badgeSize}>
      Not Started
    </Badge>
  );
}

export const FilingStatusBadgeWithDueDate = ({
  status,
  syntheticStatus,
  dueDate,
}: {
  status: ComplianceStatus;
  syntheticStatus: SyntheticComplianceStatus;
  dueDate: string;
}) => {
  if (!dueDate) return null;
  return (
    <div className="flex items-center gap-lg border border-border-primary text-text-quaternary rounded-md px-md py-sm text-sm">
      <span className="text-text-quaternary txt-small-medium">
        Due:{' '}
        {NonTimezoneSensitiveDate.fromISO8601String(dueDate).format(
          'MMM D, YYYY'
        )}
      </span>
      <FilingStatusBadge status={status} syntheticStatus={syntheticStatus} />
    </div>
  );
};
